const toLower = (str) => {
    const regex = /[^a-z]+/gi;

    return str.toLowerCase().replace(regex, '-');
};

export default toLower;



// WEBPACK FOOTER //
// ./src/utils/toLower.js